module.exports = __webpack_public_path__ + "static/media/charity-2.77e3fbac.png";